<div class="container-fluid cw-background">
  <div class="row d-flex justify-content-center">
    <div class="col-12 col-sm-9 col-sm-offset-1 col-md-9 col-md-offset-1 col-lg-4 col-lg-offset-4 mt-5 mb-5">
      <mat-card class="mat-elevation-z8 mt-4 mb-4" id="card">
        <div class="ticket-create-controls-wrapper">
          <button (click)="goBack()" disableRipple mat-button class="delete-user p-0">
            <mat-icon matPreffix>arrow_back_ios</mat-icon>
            Go Back
          </button>
        </div>
        <div *ngIf="asset && asset.serialNumber; noAsset" class="text-left go-back d-block">
          <h6 class="text-center card-title-page mb-4">
            Create New Ticket for asset: {{ asset.name }} - {{ asset.serialNumber }} - {{ asset.modelNumber }}
          </h6>
        </div>
        <h6 #noAsset class="text-center card-title-page mb-4">Create New Ticket</h6>
        <div class="row d-flex justify-content-center">
          <div class="col-12 col-sm-9 col-sm-offset-1">
            <app-dynamic-form [questions]="questions" (hasChanged)="onChange($event)" (formSubmit)="onSubmit($event)">
            </app-dynamic-form>
          </div>
        </div>
      </mat-card>
    </div>
  </div>
</div>
